var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPaperAirplane28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0116 5.21462C22.8557 4.99533 22.6162 4.85427 22.3542 4.82129L22.3313 4.80542L22.1825 4.813C22.0766 4.8184 21.9721 4.84137 21.8732 4.88142L21.8714 4.88215L5.4016 11.6378L5.39983 11.6385C5.16686 11.7353 4.98166 11.9204 4.885 12.1537C4.78833 12.387 4.78833 12.6492 4.88501 12.8825C4.98146 13.1153 5.16624 13.3006 5.39927 13.3974L5.40016 13.3978L11.8907 16.108L14.6005 22.5988C14.6972 22.8324 14.8831 23.0174 15.1158 23.114C15.3492 23.2107 15.6118 23.2104 15.8451 23.1138C16.0781 23.0171 16.2634 22.8319 16.3601 22.5986L16.3607 22.5971L23.1164 6.12723C23.2402 5.82522 23.2005 5.48074 23.0116 5.21462ZM12.3935 14.2564L8.25273 12.5275L18.2043 8.44534L12.3935 14.2564ZM15.4689 19.7434L13.74 15.6026L19.5511 9.79178L15.4689 19.7434Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaperAirplane28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;